function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" {...props}><path d="M17.747.856A1.75 1.75 0 0 0 17 .175 1.73 1.73 0 0 0 16.25 0H1.75c-.27 0-.522.066-.75.175a1.75 1.75 0 0 0-.747.681A1.736 1.736 0 0 0 0 1.75v10.5C0 13.216.784 14 1.75 14h14.5A1.75 1.75 0 0 0 18 12.25V1.75c0-.328-.096-.631-.253-.894zM15.998 1L9 6.76 2.002 1h13.996zM17 12.25a.75.75 0 0 1-.75.75H1.75a.75.75 0 0 1-.75-.75V1.75c0-.085.022-.163.048-.239L8.199 7.4 9 8.041l.801-.641 7.151-5.889A.732.732 0 0 1 17 1.75v10.5z" /></svg>;
});